export enum PlanEnum {
  Base,
  Intermediate,
  Enterprise,
  Advanced,
}
